import React from "react";
import { getUsersWithoutBiometrics, getUsersWithoutCustomIds, getUsersWithoutNames, getUsersWithoutShifts } from "../user/userStore";
import Jumbotron from "../general/Jumbotron.jsx";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    render() {
        return (
            <div>
                <Jumbotron title="Scadsys Biometrics" text="Welcome to Scadsys Biometrics"></Jumbotron>
            </div>
        );
    }
}
